import { render, staticRenderFns } from "./AppMobileConfigScreen.vue?vue&type=template&id=316df13c&scoped=true&"
import script from "./AppMobileConfigScreen.vue?vue&type=script&lang=js&"
export * from "./AppMobileConfigScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316df13c",
  null
  
)

export default component.exports